/**
 * 所有接口变量都以 api开头，例如：apiGetUserInfo
 */
import { apiPost } from 'utils'
import { ILoginRequest, ILoginResponse } from 'model'
import { XhhyRequest, XhhyResponse } from 'Xhhy-common/common'
  
  /**
   * 登录
   * @param params
   */
  export const apiLogin = async (params: ILoginRequest) => {
   return await apiPost<ILoginRequest, ILoginResponse>(`/apppocapi/auth/login`, params)
  }

  /**
   * 退出登录
   * @param params
   */
   export const apiLoginOut = async (params: XhhyRequest) => {
    return await apiPost<XhhyRequest, XhhyResponse>(`/apppocapi/auth/logout`, params)
   }

 
  